<template>
	<div class="parts-locations-sms-email-card-edit">
		<!-- Parts Invoice Section -->
		<SectionContainer>
			<template #left>
				<h4>Part Invoice</h4>
				<p>Lorem ipsum description text</p>
			</template>
			<template #content>
				<Dropdown
					label="Email Provider"
					v-model="localData.partsInvoice.emailProvider"
					:options="emailProviderTypeOptions"
				/>
				<Dropdown
					label="Reply-To Email"
					v-model="localData.partsInvoice.replayToEmail"
					:options="replayToEmailTypeOptions"
				/>
				<Dropdown
					label="SMS Provider"
					v-model="localData.partsInvoice.smsProvider"
					:options="smsProviderTypeOptions"
				/>
			</template>
		</SectionContainer>
		<!-- Parts Desk Section -->
		<SectionContainer>
			<template #left>
				<h4>Part Desk</h4>
				<p>Lorem ipsum description text</p>
			</template>
			<template #content>
				<Dropdown
					label="Email Provider"
					v-model="localData.partsDesk.emailProvider"
					:options="emailProviderTypeOptions"
				/>
				<Dropdown
					label="Reply-To Email"
					v-model="localData.partsDesk.replayToEmail"
					:options="replayToEmailTypeOptions"
				/>
				<Dropdown
					label="SMS Provider"
					v-model="localData.partsDesk.smsProvider"
					:options="smsProviderTypeOptions"
				/>
			</template>
		</SectionContainer>
		<!-- Special Order Parts Section -->
		<SectionContainer>
			<template #left>
				<h4>Part Desk</h4>
				<p>Lorem ipsum description text</p>
			</template>
			<template #content>
				<Dropdown
					label="Email Provider"
					v-model="localData.specialOrderParts.emailProvider"
					:options="emailProviderTypeOptions"
				/>
				<Dropdown
					label="Reply-To Email"
					v-model="localData.specialOrderParts.replayToEmail"
					:options="replayToEmailTypeOptions"
				/>
				<Dropdown
					label="SMS Provider"
					v-model="localData.specialOrderParts.smsProvider"
					:options="smsProviderTypeOptions"
				/>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import _ from 'lodash';

export default {
	name: 'PartsLocationsSmsEmailCardEdit',
	components: { SectionContainer, Dropdown },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			emailProviderTypeOptions: ['lorem', 'ipsum', 'dolor'],
			replayToEmailTypeOptions: ['lorem@email.com', 'ipsum@email.com'],
			smsProviderTypeOptions: ['lorem', 'ipsum', 'dolor']
		};
	},
	created() {
		// console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.parts-locations-sms-email-card-edit {
	&__item {
		display: block;
	}
}
</style>
